import { render } from "./PropertyNotes.vue?vue&type=template&id=959e26c4&ts=true"
import script from "./PropertyNotes.vue?vue&type=script&lang=ts"
export * from "./PropertyNotes.vue?vue&type=script&lang=ts"

import "./PropertyNotes.vue?vue&type=style&index=0&id=959e26c4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__